<div class="row">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-12">
                <span class="ml-2">Information</span>
            </div>

        </div>
        <div *ngIf="title=='classification'">
        <form [formGroup]="form">
        <div class="card card_content ">
            <p style="font-size: x-large;">Do you want to buy?</p>
            <div class="col-sm-12 col-md-6 mt-3">
                <div class="col-sm-12 col-md-12 align-self-center" style="display: flex; align-items: center;">
                  <mat-radio-group formControlName="productClassification" style="display: flex; flex-direction: row; gap: 80px;">
                    <mat-radio-button value="1">FTTH</mat-radio-button>
                    <mat-radio-button class="ml-4" value="2">FTTB</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div> 
              
              <div class="d-flex justify-content-end button-style mt-3">

                <button class="btn btn-secondary my-2 " type="submit" (click)="save()"
                    matButton>Ok</button>
                   
            </div> 
        </div>
        </form>
        </div>

        <div *ngIf="title=='isont'">
            <form [formGroup]="form">
            <div class="card card_content ">
                <p style="font-size: x-large;">Are you switching from another Fibre ISP to Home-Connect?</p>
                <div class="col-sm-12 col-md-6 mt-2">
                    <div class="col-sm-12 col-md-12 align-self-center" style="display: flex; align-items: center;">
                      <mat-radio-group formControlName="isont" style="display: flex; flex-direction: row; gap: 80px;" (change)="click()">
                        <mat-radio-button value="1">Yes</mat-radio-button>
                        <mat-radio-button class="ml-4" value="2">No</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div> 
                  
                  <div class="mt-3  ml-2" *ngIf="yesmesg || nomesg">
                    <p style="font-size: large;" class="mb-0" *ngIf="yesmesg">To assist you with the migration, you will be prompted to fill current Fibre ISP details during the application Sign Up.</p>
                    <p style="font-size: large;" class="mb-0" *ngIf="nomesg">Please note that Home-Connect will arrange a new installation order  with the service provider.</p>
                  </div>
                  
                  <div class="d-flex justify-content-end button-style mt-2">
    
                    <button class="btn btn-secondary my-2 " [disabled]="!(yesmesg || nomesg)" type="submit" (click)="simsave()"
                        matButton>Ok</button>
                       
                </div> 
            </div>
            </form>
            </div>
    </div>
</div>